
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

interface BlogPostLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
  notFound?: boolean;
}

const BlogPostLayout: React.FC<BlogPostLayoutProps> = ({ 
  children, 
  isLoading = false,
  notFound = false 
}) => {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden relative">
      <ScrollToTop />
      <Header />

      <main className="pt-24 pb-16">
        <div className="section-container">
          {!isLoading && !notFound && (
            <div className="mb-8">
              <Link to="/blog" className="inline-flex items-center text-primary hover:underline">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Writing
              </Link>
            </div>
          )}

          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BlogPostLayout;
